import { z } from "zod";

export const portfolioContextListingSchema = z.object({
  unit: z.object({
    id: z.string().uuid(),
    title: z.string(),
    unitType: z.number(),
    propertyBusinessId: z.string().uuid(),
  }),
  business: z.object({
    id: z.string().uuid(),
    businessType: z.number(),
    propertyId: z.string().uuid(),
  }),
  portfolio: z.object({
    id: z.string().uuid(),
    title: z.string(),
  }),
});

export type PortfolioContextListing = z.infer<
  typeof portfolioContextListingSchema
>;
